if (!customElements.get('dut-footer-menus')) {
  customElements.define('dut-footer-menus', class extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(max-width: 749px)');
      this.panels = [...this.querySelectorAll('details')];
      this.applyLayout = () => this.panels.forEach((panel, index) => {
        panel.open = !this.media.matches || index === 0;
      });
      this.keepDesktopOpen = (event) => {
        if (!this.media.matches && event.target instanceof HTMLDetailsElement) event.target.open = true;
      };
      this.onBlockSelect = (event) => {
        if (this.contains(event.target)) {
          const panel = event.target.closest('details');
          if (panel) panel.open = true;
        }
      };
      this.backToTop = this.closest('.def')?.querySelector('[data-dut-back-to-top]');
      this.stopScroll = () => cancelAnimationFrame(this.scrollFrame);
      this.onBackToTop = (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        window.dutScrollTo(document.body, '#top');
      };
      ['wheel', 'touchstart', 'keydown'].forEach(type => window.addEventListener(type, this.stopScroll, { passive: true }));
      this.applyLayout();
      this.media.addEventListener('change', this.applyLayout);
      this.addEventListener('toggle', this.keepDesktopOpen, true);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.backToTop?.addEventListener('click', this.onBackToTop);
    }
    disconnectedCallback() {
      this.stopScroll();
      ['wheel', 'touchstart', 'keydown'].forEach(type => window.removeEventListener(type, this.stopScroll));
      this.media.removeEventListener('change', this.applyLayout);
      this.removeEventListener('toggle', this.keepDesktopOpen, true);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.backToTop?.removeEventListener('click', this.onBackToTop);
    }
  });
}
